// extracted by mini-css-extract-plugin
export var actions = "_3j-0";
export var actionsContainer = "_3j-7";
export var border = "_3j-1";
export var childFullHeight = "_3j-f";
export var collapse = "_3j-2";
export var content = "_3j-a";
export var contentChild = "_3j-e";
export var fullscreen = "_3j-c";
export var hasLeftRadius = "_3j-k";
export var headerContainer = "_3j-3";
export var headerRow = "_3j-5";
export var hidePadding = "_3j-b";
export var navCollapsedGap = "_3j-l";
export var noScrollX = "_3j-m";
export var noScrollY = "_3j-n";
export var noTopPadding = "_3j-i";
export var optOutTopPadding = "_3j-d";
export var pageMain = "_3j-j";
export var pageOuter = "_3j-g";
export var pagePadding = "_3j-8";
export var pageScroll = "_3j-9";
export var profile = "_3j-o";
export var profileContainer = "_3j-p";
export var profileImage = "_3j-q";
export var profileMain = "_3j-r";
export var profileSubtitle = "_3j-t";
export var profileTitle = "_3j-s";
export var showLeftPadding = "_3j-h";
export var tabsPortalSlot = "_3j-6";
export var tabsWrapper = "_3j-4";
export var title = "_3j-u";